import React, { Component } from 'react';
import './index.scss';
import SvgZoomMap from '../../utils/SvgZoomMap';
import MapIsland from '../EvacuationChartMapIsland';
import LoadingDots from '../../utils/LoadingDots';

// methods
import { transferHundredPoint } from '../../utils/Shared/methods';
import Axios from 'axios';
import { apiHost, loginApiHost } from '../../utils/Shared/constant';

class EvacuationChartMap extends Component {
	constructor(params) {
		super(params);
		this.state = {
			isMapShow: false,
			isDataLoad: false,
			isColorMarkHide:false,
			gap: 6,
			colorSet: [
				{ unit: "人次", gap: 6, colors: ['#FBE9F2', '#EEE0F4', '#D0D1E6', '#A6BDDB', '#67AACF', '#3690C0', '#337BB6'] },
				{ unit: "次數", gap: 7, colors: ['#FCF0B7', '#FCE298', '#FCC779', '#FDAC6F', '#FC8063', '#E75858', '#C84864', '#A73B58'] },
			],
			colors: [],
			curcolors:[],
			ranges: [],
			isBubbleShow: false,
			bubble: {
				name: null,
				avarge: null,
				sum: null,
				event: null,
				count: null
			},
			bubbleTop: 0,
			bubbleLeft: 0,
			county: '',
			town: '',					
			zeroPositionPercent: '50',
			svgId :"svgMap",
			villageSrc :'taiwan-village.json'			
		};
	}

	componentDidMount() {		
		this.getVersion();
		this.getRanges();			
		this.MapRest();	
	}
	componentDidUpdate(prevProps, prevState) {		
		if (prevProps !== this.props) {
			this.MapRest();
			this.getRanges();			
		}
	}
	getVersion(){
		Axios.get(
			`${apiHost}/api/ShelterInfo/GetVersion`
		).then((res)=>{			
			this.setState({villageSrc: res.data.version})
		})
	}

	getRanges() {
		const { evacuationData } = this.props;		
		if (evacuationData) {
			const { unit, transferValue } = evacuationData;
			const set = this.state.colorSet.find(item => item.unit === unit);
			const { gap, colors } = set;
			const maximum = Math.max(...evacuationData.data.map(data => data[transferValue]));
			const minimum = Math.min(...evacuationData.data.map(data => data[transferValue]));
			const dataGap = (maximum - minimum) <= gap*2 ? Math.max(Math.floor((maximum - minimum)/2), 1) : gap; 
			const min = (maximum - minimum) / dataGap;
			const digits = Math.ceil(min).toString().length - 1;
			let delta;
			const base = Math.floor(minimum / Math.pow(10, digits)) * Math.pow(10, digits);
			if (digits <= 1)  { delta = Math.ceil(min) };
			if (digits > 1) { delta = Math.ceil(min / Math.pow(10, digits)) * Math.pow(10, digits) };
			const allDataIsNull = evacuationData.data.every(data => data[transferValue] === null);
			const ranges = [];
			for (let i = 0; i < dataGap-1; i ++) {
				ranges.push(base + (delta * (i+1)));
			};
			ranges.push(maximum);


			let targetAttribute;
			if(unit === "人次"){
				targetAttribute= 'data-avarge';
			}
			else{
				targetAttribute= 'data-count';
			}


			this.setState({
				unit: unit,
				colors: colors,
				ranges: ranges,
				rangeBase: base,
				isColorMarkHide:allDataIsNull,
				zeroPositionPercent: Math.abs((minimum /(maximum - minimum)*100)),	
				targetAttribute:targetAttribute			
			}, () => this.handleLoadData());
		}
	}
	handleLoadData = () => {
		const { evacuationData } = this.props;
		const { transferValue } = evacuationData;
		const{colors} = this.state;
		if (evacuationData) {
			const { county, town } = evacuationData;
			const mapData = {
				layer: '',
				data: []
			};

			if (county === '' && town === '') {
				mapData.layer = 'county';
			}
			else if (county !== '' && town === '') {
				mapData.layer = 'town';
			}
			else {
				mapData.layer = 'village';
			}
			
			evacuationData.data.forEach(item => {
				const obj = {};
				obj.name = item.Name;
				obj.attribute = {
					'style': {
						'fill': this.handleTransferColor(item[transferValue]),
						'stroke': '#555555',
					},
					'data-sum': item.Sum,
					'data-avarge': item.Avarge,
					'data-event': item.Event,
					'data-count': item.Value,
				}
				mapData.data.push(obj);				
			});

			this.setState({
				mapData: mapData,
				county: county,
				town: town,
			},()=>{this.getColorBar(colors)})
		}		
	}
	handleTransferColor = (value) => {
		const { ranges, colors} = this.state;
		let color;
		for (let i = 0; i < ranges.length; i++) {
			if ( value >= ranges[i] && value < ranges[i+1]) {
				color = colors[i + 1];
			}
		}
		if ( value <= ranges[0]) {
			color = colors[0];
		}
		if (value >= ranges[ranges.length - 1]) {
			color = colors[ranges.length];
		}
		if (value === 0) {
			color = '#eee';
		}
		return color;
	}
	handleMouseOverMap = (area, e) => {
		this.setState({
			isBubbleShow: true,
			bubbleTop: e.clientY,
			bubbleLeft: e.clientX,
			bubble: {
				name: e.target.dataset.name || area.filter(_ => _).slice(-1),
				avarge: e.target.dataset.avarge  || null,
				sum: e.target.dataset.sum  || null,
				event: e.target.dataset.event  || null,
				count: e.target.dataset.count  || null,
			},
		})
	}
	handleMouseLeaveMap = () => {
		this.setState({
			isBubbleShow: false,
		})
	}

	getColorBar = (colorSet) => {
		const {mapData} = this.state;
		let colorBar = ''		
		let maxIndex = this.getMaxColorIndex(mapData.data, colorSet);		
		let endIndex = maxIndex		
		if(endIndex === 1){endIndex++;}		
		colorBar = colorSet.slice(0,endIndex).join(',');		
		this.setState({colorBar})		
	}

	getMaxColorIndex = (data, colorSet) =>{
		let maxIndex = 0;		
		data.forEach(item =>{
			let colorCode = item.attribute.style.fill;
			let index = colorSet.indexOf(colorCode);
			if(maxIndex< index){
				maxIndex =index;
			}
		})
		return maxIndex+1;
	}

	MapRest = () =>{		
		const mapNames = document.querySelector('#svgMap .map-names')
		if(mapNames){mapNames.innerHTML='';}
	}

	MapInit = () =>
	{
		this.MapRest();
		this.HideOutlyingIslands();
		this.AppendName();
	}

	// 隱藏主 SVG 中的金門縣和連江縣（由 MapIsland 組件獨立顯示）
	HideOutlyingIslands = () => {
		const countys = document.querySelectorAll('#svgMap g .-county');
		countys.forEach((item) => {
			const countyName = item.querySelector('county').textContent;
			if (countyName === '金門縣' || countyName === '連江縣') {
				item.style.display = 'none';
			}
		});
	}

	AppendName = () => 
	{
		const {unit}= this.state;
		const countys = document.querySelectorAll('#svgMap g .-county');
		const towns = document.querySelectorAll('#svgMap g .-town');
		const village = document.querySelectorAll('#svgMap g .-village');
		const mapNames = document.querySelector('#svgMap .map-names');
		const scaleNum = this.ScaleNum();
		let fontSize = 15 * scaleNum;
		let targetAttribute = 'data-avarge';
		if(unit)
		{
			if(unit=="人次"){
				targetAttribute = 'data-avarge';
			}
			else
			{
				targetAttribute = 'data-count';
			}

		}
		if(countys.length>0)
		{
			countys.forEach((item)=> {
				// 跳過金門縣和連江縣（由 MapIsland 組件獨立顯示）
				const countyName = item.querySelector('county').textContent;
				if (countyName === '金門縣' || countyName === '連江縣') return;

				const center = this.CalSVGCenter(item);
      			const textElement = document.createElementNS("http://www.w3.org/2000/svg", "text");
				
				textElement.setAttribute("x", center.centerOfRect_X);
				textElement.setAttribute("y", center.centerOfRect_Y);
				textElement.setAttribute("dominant-baseline","middle");
				textElement.setAttribute("text-anchor","middle");
				textElement.setAttribute('font-size',fontSize );
				textElement.setAttribute('font-weight', 'bold');

				// 使用多個 tspan 元素來實現換行
				const titleText = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
				titleText.textContent = item.querySelector('county').textContent;
				titleText.setAttribute("x", center.centerOfRect_X);
				titleText.setAttribute("dy", "-1em"); // 調整垂直位置

				const averageText = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
				let dataAvarge =  item.querySelector('path').getAttribute(targetAttribute);
				const result = dataAvarge!==null?dataAvarge:'查無資料';
				averageText.textContent = result;
				averageText.setAttribute("x", center.centerOfRect_X);
				averageText.setAttribute("dy", "1em"); // 調整垂直位置

				textElement.appendChild(titleText);
				textElement.appendChild(averageText);
			
				mapNames.appendChild(textElement)
			})
		}else if(towns.length>0)
		{
			towns.forEach((item)=> {
				const center = this.CalSVGCenter(item);				
      			const textElement = document.createElementNS("http://www.w3.org/2000/svg", "text");
				
				textElement.setAttribute("x", center.centerOfRect_X);
				textElement.setAttribute("y", center.centerOfRect_Y);
				textElement.setAttribute("dominant-baseline","middle");
				textElement.setAttribute("text-anchor","middle");
				textElement.setAttribute('font-size',fontSize);
				textElement.setAttribute('font-weight', 'bold');


				// 使用多個 tspan 元素來實現換行
				const titleText = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
				titleText.textContent = item.querySelector('town').textContent;
				titleText.setAttribute("x", center.centerOfRect_X);
				titleText.setAttribute("dy", "-1em"); // 調整垂直位置

				const averageText = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
				let dataAvarge =  item.querySelector('path').getAttribute(targetAttribute);
				const result = dataAvarge!==null?dataAvarge:'查無資料';
				averageText.textContent = result;
				averageText.setAttribute("x", center.centerOfRect_X);
				averageText.setAttribute("dy", "1em"); // 調整垂直位置

				textElement.appendChild(titleText);
				textElement.appendChild(averageText);
				
				mapNames.appendChild(textElement)
			})

		}else if(village.length>0)
		{
			village.forEach((item)=> {
				const center = this.CalSVGCenter(item);				
      			const textElement = document.createElementNS("http://www.w3.org/2000/svg", "text");
				
				textElement.setAttribute("x", center.centerOfRect_X);
				textElement.setAttribute("y", center.centerOfRect_Y);
				textElement.setAttribute("dominant-baseline","middle");
				textElement.setAttribute("text-anchor","middle");
				textElement.setAttribute('font-size',fontSize);
				textElement.setAttribute('font-weight', 'bold');

				// 使用多個 tspan 元素來實現換行
				const titleText = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
				titleText.textContent = item.querySelector('village').textContent;
				titleText.setAttribute("x", center.centerOfRect_X);
				titleText.setAttribute("dy", "-1em"); // 調整垂直位置

				const averageText = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
				let dataAvarge =  item.querySelector('path').getAttribute(targetAttribute);
				const result = dataAvarge!==null?dataAvarge:'查無資料';
				averageText.textContent = result;
				averageText.setAttribute("x", center.centerOfRect_X);
				averageText.setAttribute("dy", "1em"); // 調整垂直位置

				textElement.appendChild(titleText);
				textElement.appendChild(averageText);
			
				mapNames.appendChild(textElement)
			})
		}
	}

	CalSVGCenter = (element) =>
	{
		const mySVG = element;
		// const surroundingRectangle = mySVG.getBoundingClientRect();
		const surroundingRectangle = mySVG.getBBox();
		const centerOfRect_X = surroundingRectangle.x + surroundingRectangle.width * 0.5 ;
		const centerOfRect_Y = surroundingRectangle.y + surroundingRectangle.height * 0.5;
		return {centerOfRect_X, centerOfRect_Y}
	}
	
	ScaleNum = () =>{
		const svg = document.querySelector('#svgMap');
		if(!svg){return 1}
		const vbWidth = svg.viewBox.baseVal.width;
		const width = svg.getAttribute('width');
		return vbWidth/width;
	}

	render() {	
		
		const { className } = this.props;
		const { isMapShow, isBubbleShow, bubble, bubbleTop, bubbleLeft } = this.state;
		const { colors, ranges, rangeBase, mapData, county, town, unit,targetAttribute } = this.state;
		const { colorBar, zeroPositionPercent, isColorMarkHide } = this.state;
		const{svgId} = this.state;
		const{villageSrc} = this.state;
		return (
			<div className={`evacuation-map-gradient ${className ? className : ''}`}>
				{
					isBubbleShow &&
					<div className="bubble-info"
					style={{
						'position': 'fixed',
						'top': `${bubbleTop}px`,
						'left': `${bubbleLeft}px`,
						'zIndex': 99
					}}>
						<div className="bubble">
							<p className="name">{ bubble.name }</p>
							{ bubble.avarge && <p className="value">平均： { transferHundredPoint(bubble.avarge) }</p> }
							{ bubble.sum    && <p className="value">總數： { transferHundredPoint(bubble.sum) }</p> }
							{ bubble.event  && <p className="value">事件： { transferHundredPoint(bubble.event) }</p> }
							{ bubble.count  && <p className="value">次數： { transferHundredPoint(bubble.count) }</p> }
							{
								!bubble.avarge && !bubble.sum && !bubble.event && !bubble.count && 
								<p className="value">查無資料</p>
							}
						</div>
					</div>
				}
				<div className="capture" >
					{ranges &&	
					<div className="range-mark">
							<div className="title">{ unit }</div>
							{
								<React.Fragment>									
									<div className="range-noData">
										<div className="colorBar"/>
										<div className="value">查無資料</div>
									</div>
									<div className="range">
										<div className="colorBar" style={{ background: `linear-gradient(${colorBar})` }}></div>
										<div className="valueBar">
											<div className="value type-text -en">0</div>
											<div className="value type-text -en zero" style={{top:`${zeroPositionPercent}%`}}></div>
											<div className="value type-text -en buttom">{ranges[ranges.length -1]}</div>											
										</div>
									</div>
								</React.Fragment>
							}
						</div>
						}
					
					{!isMapShow && <LoadingDots theme="red" />}
					<div className={`taiwan-map ${isMapShow && '-show'}`} onMouseLeave={this.handleMouseLeaveMap}>
						{
							mapData &&
							mapData.layer === 'county' &&
							<MapIsland
								onAreaHover={this.handleMouseOverMap}	
								infoData={mapData}/>
						}
						<SvgZoomMap
							countyJsonSrc="/MapJson/taiwan-county.json"
							townJsonSrc="/MapJson/taiwan-town.json"
							villageJsonSrc={`/Admin/Files/TopoJson/${villageSrc}`}
							onAreaHover={this.handleMouseOverMap}
							county={county}
							town={town}
							infoData={mapData}
							zoomDelay={0}
							isMapInit={() => { this.setState({ isMapShow: true }) }}
							ignoreArea={['金門縣', '連江縣']}
							// zoomDuration={0}
						/>
					</div>
				</div>

				<div className="captureText captureText-hidden" style={{position:'absolute',top: '-9999px'}}>				
					{ranges &&	
					<div className="range-mark" style={{top:'auto', left:'auto'}}>
							<div className="title">{ unit }</div>
							{
								<React.Fragment>									
									<div className="range-noData">
										<div className="colorBar"/>
										<div className="value">查無資料</div>
									</div>
									<div className="range">
										<div className="colorBar" style={{ background: `linear-gradient(${colorBar})` }}></div>
										<div className="valueBar">
											<div className="value type-text -en">0</div>
											<div className="value type-text -en zero" style={{top:`${zeroPositionPercent}%`}}></div>
											<div className="value type-text -en buttom">{ranges[ranges.length -1]}</div>											
										</div>
									</div>
								</React.Fragment>
							}
						</div>
						}
					
					{!isMapShow && <LoadingDots theme="red" />}
					<div className={`taiwan-map ${isMapShow && '-show'}`} onMouseLeave={this.handleMouseLeaveMap}>
						{
							mapData &&
							mapData.layer === 'county' &&
							<MapIsland
								onAreaHover={this.handleMouseOverMap}	
								infoData={mapData}
								showName={true}
								targetAttribute={targetAttribute} />
						}
						<SvgZoomMap
							svgId={svgId}
							countyJsonSrc="/MapJson/taiwan-county.json"
							townJsonSrc="/MapJson/taiwan-town.json"
							villageJsonSrc={`/Admin/Files/TopoJson/${villageSrc}`}							
							onAreaHover={this.handleMouseOverMap}
							county={county}
							town={town}
							infoData={mapData}
							zoomDelay={0}
							isMapInit={() => { this.setState({ isMapShow: true }) }}
							isMapUpdate = {() =>{this.MapInit();}}
							// zoomDuration={0}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default EvacuationChartMap;
